import React from "react";
import PropTypes from "prop-types";
import { DefaultButton, ButtonIconHolder, LoadingIconHolder, SvgIconHolder } from "./Button.styles";
import ButtonProps from "./Button.types";

/**
 * BW Button component.
 */
const Button: React.FC<ButtonProps> = ({
    children,
    disabled,
    iconURL,
    iconSvg,
    iconSize,
    isLoading,
    loadingIconURL,
    loadingIconSize,
    ...rest
}) => {
    loadingIconURL = loadingIconURL ?? "";
    return (
        <DefaultButton
            disabled={disabled}
            tabIndex={disabled ? -1 : 0}
            iconURL={iconURL}
            iconSvg={iconSvg}
            isLoading={isLoading}
            {...rest}
        >
            {!iconSvg && iconURL && <ButtonIconHolder iconSize={iconSize} iconURL={iconURL} />}
            {iconSvg && <SvgIconHolder iconSize={iconSize}>{iconSvg}</SvgIconHolder>}
            {isLoading && (
                <LoadingIconHolder loadingIconSize={loadingIconSize} xmlns="http://www.w3.org/2000/svg">
                    <title>loading icon</title>
                    <image href={loadingIconURL} />
                </LoadingIconHolder>
            )}
            {children}
        </DefaultButton>
    );
};

Button.defaultProps = {
    type: "button",
    variant: "primary",
    color: "white",
    iconSize: 14,
    iconPosition: "right",
    fullWidth: false,
    disabled: false,
    loadingIconURL: "https://static.breakingwave.com/images/icons/animated/thinking_anim_lightgray.gif",
    loadingIconSize: 16
};

Button.propTypes = {
    children: PropTypes.node.isRequired,
    type: PropTypes.oneOf(["button", "submit", "reset"]),
    variant: PropTypes.oneOf(["primary", "secondary", "tertiary"]),
    color: PropTypes.oneOf(["blue", "black", "white"]),
    iconURL: PropTypes.string,
    iconSize: PropTypes.number,
    iconPosition: PropTypes.oneOf(["left", "right"]),
    fullWidth: PropTypes.bool,
    disabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    loadingIconURL: PropTypes.string,
    loadingIconSize: PropTypes.number
};

export default Button;
